"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedTop = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
/**
 * viewport 상단 고정만 담당하는 레이아웃 primitive.
 * sticky로 흐름에 남아 자기 높이만큼 공간을 차지하므로, 뒤따르는 형제가 그 아래에서 시작한다.
 * 높이, 간격, 배경과 내부 배치는 사용처에서 결정한다.
 */
let FixedTop = class FixedTop extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
FixedTop.styles = (0, lit_1.css) `
    :host {
      display: block;
      padding-top: env(safe-area-inset-top);
      box-sizing: border-box;
      position: sticky;
      top: 0;
      z-index: var(--material-zindex-chrome);
    }

    /* slot이 사이에 끼면 배경 상속이 끊겨, 자식이 부모 배경을 따르지 못한다. */
    slot {
      background: inherit;
    }
  `;
FixedTop = __decorate([
    (0, decorators_js_1.customElement)('mm-fixed-top')
], FixedTop);
exports.FixedTop = FixedTop;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZml4ZWQtdG9wLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZml4ZWQtdG9wLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBaUQ7QUFFakQ7Ozs7R0FJRztBQUVJLElBQU0sUUFBUSxHQUFkLE1BQU0sUUFBUyxTQUFRLGdCQUFVO0lBaUJ0QyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUFwQk0sZUFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7OztHQWNsQixDQUFBO0FBZlUsUUFBUTtJQURwQixJQUFBLDZCQUFhLEVBQUMsY0FBYyxDQUFDO0dBQ2pCLFFBQVEsQ0FzQnBCO0FBdEJZLDRCQUFRIn0=